module.exports = __webpack_public_path__ + "media/domenj/favicon-1241bcaf.ico";